// @ts-strict-ignore
import { allowedImpersonationPathPatterns } from "../constants";

/**
 * Determines whether a request should be allowed without confirmation
 * @param url URL returned from enhanceFetchArgs
 * @param fetchOptions fetchOptions returned from enhanceFetchArgs
 * @returns whether this request is allow-listed in an impersonation context
 */
export const allowRequest = (url: string, fetchOptions: RequestInit) => {
  const method = fetchOptions.method;
  if (method.toUpperCase() === "GET") {
    return true;
  }
  const contentType =
    fetchOptions.headers?.["Content-Type"] ||
    fetchOptions.headers?.["content-type"] ||
    fetchOptions.headers?.["content-Type"] ||
    fetchOptions.headers?.["Content-type"];
  if (contentType === "text/html") {
    return true;
  }
  return allowedImpersonationPathPatterns.some((pattern) => pattern.test(url));
};
